import { AlertTriangle } from "lucide-react"
import { Switch } from "@/components/ui/switch"

interface ValidationFailuresButtonProps {
  errorModeActive: boolean
  onToggle: (value: boolean) => void
  variant?: "button" | "toggle"
}

export default function ValidationFailuresButton({
  errorModeActive,
  onToggle,
  variant = "button",
}: ValidationFailuresButtonProps): React.JSX.Element {
  if (variant === "toggle") {
    return (
      <label className="flex align-baseline w-full cursor-pointer items-center gap-2 rounded-xl border border-border/60 bg-background/80 px-3 py-2 shadow-xl ring-1 ring-black/5 backdrop-blur-md">
        <Switch
          size="sm"
          checked={errorModeActive}
          onCheckedChange={onToggle}
          aria-label="Toggle validation failures"
          className="shrink-0 data-[state=checked]:bg-red-600 data-checked:bg-red-600"
        />
        <span className="flex-1 whitespace-nowrap text-[11px] font-semibold uppercase tracking-wider text-foreground/80 pt-0.5">
          Validation failures
        </span>
      </label>
    )
  }

  return (
    <button
      type="button"
      aria-pressed={errorModeActive}
      onClick={() => onToggle(!errorModeActive)}
      title={
        errorModeActive
          ? "Showing validation failures — click to return to the normal map"
          : "Show clusters that failed validation"
      }
      className={[
        "flex w-full items-center justify-center gap-1",
        "rounded-xl border px-3 py-2 text-xs font-semibold uppercase tracking-wider shadow-xl ring-1 ring-black/5",
        "backdrop-blur-md transition-colors",
        errorModeActive
          ?
            "border-red-600 bg-red-600 text-white hover:bg-red-700"
          :
            "border-red-500/40 bg-background/80 text-red-600 hover:bg-red-500/10 dark:text-red-400",
      ].join(" ")}
    >
      <AlertTriangle className="size-3.5 shrink-0" aria-hidden="true" />
      {errorModeActive ? "Showing validation failures" : "Show Validation failures"}
    </button>
  )
}